import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { GlobalProvider } from './context/GlobalContext';

// ✅ Create MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// ✅ Handle redirect before mounting the app to avoid flicker back to /auth
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Handle chunk load errors - common issue with code splitting in production
window.addEventListener('error', (event) => {
  const error = event.error;
  // Check if it's a chunk load error
  if (
    error && 
    (error.message && error.message.includes('Loading chunk') || 
     error.name === 'ChunkLoadError' ||
     (event.target && (event.target as HTMLElement).tagName === 'SCRIPT'))
  ) {
    console.warn('Chunk load error detected, attempting to reload page...');
    // Try to reload the page after a short delay
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
}, true);

// Handle unhandled promise rejections for chunk loading
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  if (error && (
    (error.message && error.message.includes('Loading chunk')) ||
    error.name === 'ChunkLoadError' ||
    (error.toString && error.toString().includes('chunk'))
  )) {
    console.warn('Chunk load error in promise rejection, attempting to reload page...');
    event.preventDefault(); // Prevent default error handling
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
});

const bootstrap = async () => {
  try {
    // Apply theme on initial load
    const savedTheme = sessionStorage.getItem("theme") as 'light' | 'dark' || 'light';
    const root = document.documentElement;
    if (savedTheme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }

    // Initialize (optional but recommended with newer MSAL versions)
    // @ts-ignore - initialize may not exist on older minor versions
    if (typeof (msalInstance as any).initialize === 'function') {
      await (msalInstance as any).initialize();
    }
    const response = await msalInstance.handleRedirectPromise();
    if (response?.account) {
      msalInstance.setActiveAccount(response.account);
    } else {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
      }
    }
  } catch (e) {
    // swallow
  } finally {
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <GlobalProvider>
            <App />
          </GlobalProvider>
        </MsalProvider>
      </React.StrictMode>
    );
  }
};

bootstrap();
